import { type BaseNotificationData, type NotificationDefinition } from "../index";
import { NotificationType } from "../NotificationType";

export interface ReleaseNotesNotificationData extends BaseNotificationData {
  subTypeCode: NotificationType.ReleaseNotes;
  title: string;
  content: string;
}

export const ReleaseNotesNotificationDefinition: NotificationDefinition<ReleaseNotesNotificationData> = {
  type: NotificationType.ReleaseNotes,
  renderTitle: (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data.title }} />;
  },
  renderTitleGA: (data) => {
    return `${data.title}`;
  },
  renderContents: (data, { markAsRead }) => {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: data.content }}
        onClick={(e) => {
          if ((e.target as HTMLElement)?.closest("a") !== null) {
            markAsRead(data);
          }
        }}
      />
    );
  },
};
